exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: diablo) {\n.smallPromptText[data-v-4a804fed] {\n    color: rgba(255,255,255,0.6);\n}\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-status/diablo.css"],"names":[],"mappings":";AAAA;AACE;IACE,6BAA6B;CAC9B;CACF","file":"diablo.css","sourcesContent":["@media screen and (weex-theme: diablo) {  \n  .smallPromptText {\n    color: rgba(255,255,255,0.6);\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a804fed","scoped":true,"hasInlineConfig":false}!./packages/dof-status/diablo.css
// module id = 189
// module chunks = 0 1